/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Trash = props => (
  <svg
    viewBox="0 0 128 128"
    width="1em"
    height="1em"
    {...props}
    cursor="pointer"
  >
    <title>{props.title || 'Slett'}</title>
    <path d="M39.7 51.2h9v56.3h-9zM58.9 51.2h9v56.3h-9zM79.4 51.2h9v56.3h-9z" />
    <path d="M80.7 11.5V0H47.4v11.5H9v28.2h10.2V128h89.6V39.7h9V11.5H80.7zM56.4 9h15.4v2.6H56.4V9zm43.5 110H28.2V41h71.7v78zm9-88.3H18V20.5h90.9v10.2z" />
  </svg>
);

export default extendIcon(Trash);
